export const LIST_HEADER_COLOR = "#004986";
export const BOLD_TEXT_COLOR = "#005AA0";
export const ANDON_HEADER_COLOR = "#545359";
